import React, { useContext, useEffect, useState } from 'react'
 
import { Context } from "../../components/contexts/AppContext";
import { useParams } from 'react-router-dom';
import { getData } from '../../lib/utils';

function TitleSubtitleUpdate() {
   const { value } = useContext(Context);  
   const [appState, setAppState] = value; 
  // console.log('app state to client....',appState)
   const { galleryId } = useParams();
   const [fontTitle, setFontTitle] = useState(String(appState.currentFontFamilyVideoTitle));
   const [fontSubTitle, setFontSubTitle] = useState(appState.currentFontFamilyVideoSubTitle);

   console.log(fontTitle," === TITLE  === ",appState.currentFontFamilyVideoTitle);
   /*
   // Fetch data when component mounts or galleryId changes
   useEffect(() => {
     const fetchData = async () => {
       try {
         const response = await getData(`galleries/gallery/${galleryId}`);
 
         if (response) {
           console.log("Response ==== ", response);     
 
           const obj = {
             name: response.folder?.name || "",
             id: response.folder?._id || "",
             galleries: [response.gallery] || [],
             adminId:response.folder?.adminId || "",
           };
 
           setAppState((prevState) => ({
             ...prevState,
             currentFolderData: obj,
             gallery:response.gallery,
             
             videoArr: response.videos || [],
             currentGalleryName: response.gallery?.name || "",
             currentGalleryVideoTitle: response.gallery?.title || "",
             currentGalleryVideoSubTitle: response.gallery?.subtitle || "",
             currentFontFamilyVideoTitle: response.gallery?.fheading || "",
             currentFontFamilyVideoSubTitle: response.gallery?.fbody || "",
             selectedVideos: response.gallery?.selectedVideos || "",
             currentGalleryData: response.gallery,
             
           }));
 
           // ✅ Set Title and Subtitle in Local State
           
         }
       } catch (error) {
         console.error("Error fetching gallery data:", error);
       }
     };
 
     fetchData(); // Call the async function
   }, [galleryId]); // Ensure effect runs when galleryId changes*/
  return (
    <div className='m-8 text-left  text-white text-3xl sm:text-5xl'>
    <div style={{ fontFamily:appState.currentFontFamilyVideoTitle,  textShadow: "2px 2px 4px black"}} className='font-semibold'>{appState.currentGalleryVideoTitle}</div>
    <div style={{ fontFamily:appState.currentFontFamilyVideoSubTitle,  textShadow: "2px 2px 4px black"}} className='text-sm'>{appState.currentGalleryVideoSubTitle}</div>
     
    </div>
  )
}

export default TitleSubtitleUpdate